import { render, staticRenderFns } from "./BlockPlain.vue?vue&type=template&id=77888fbb"
import script from "./BlockPlain.vue?vue&type=script&lang=js"
export * from "./BlockPlain.vue?vue&type=script&lang=js"
import style0 from "./BlockPlain.vue?vue&type=style&index=0&id=77888fbb&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports